import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutofocusDirective } from './autofocus.directive';
import { BlurOnEscapeDirective } from './blur-on-escape.directive';
import { EventFenceDirective } from './event-fence.directive';
import { FlagExternalDirective } from './flag-external.directive';
import { FlagInternalDirective } from './flag-internal.directive';
import { LazyCardsDirective } from './lazy-cards.directive';
import { SelectOnFocusDirective } from './select-on-focus.directive';
import { IE11HideDirective } from './ie11-hide.directive';
import { IE11ShowDirective } from './ie11-show.directive';
import { FlagApplicationDirective } from './flag-application.directive';
import { SupportLinkDirective } from './support-link.directive';

@NgModule({
  declarations: [
    AutofocusDirective,
    BlurOnEscapeDirective,
    EventFenceDirective,
    FlagApplicationDirective,
    FlagExternalDirective,
    FlagInternalDirective,
    LazyCardsDirective,
    SelectOnFocusDirective,
    IE11HideDirective,
    IE11ShowDirective,
    SupportLinkDirective,
  ],
  exports: [
    AutofocusDirective,
    BlurOnEscapeDirective,
    EventFenceDirective,
    FlagApplicationDirective,
    FlagExternalDirective,
    FlagInternalDirective,
    LazyCardsDirective,
    SelectOnFocusDirective,
    IE11HideDirective,
    IE11ShowDirective,
    SupportLinkDirective,
  ],
  imports: [CommonModule],
})
export class DirectivesModule {}
